import type { StaffRole } from '@ucp/web/lib';

/**
 * Every role that holds a `referral_*` capability (capabilities.ts). Mirrors the
 * server role→capability map; `L6_PLATFORM_ADMIN` is DELIBERATELY absent (ADR-018
 * decision 3 / EoP — never a referral shortcut). Extracted from `ReferralsSurface`
 * into this dependency-light module so the `AppRoutes` route guard can import it
 * without pulling the (now lazy-loaded) `ReferralsSurface` into the initial bundle.
 * `ReferralsSurface` re-exports it for back-compat.
 */
export const REFERRAL_ROLES: readonly StaffRole[] = [
  'REFERRAL_REGISTRAR',
  'REFERRAL_REVIEWER',
  'ADMISSIONS_DIRECTOR',
];
